
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es-mx/ia/rastreo-de-cargas",
      function () {
        return require("private-next-pages/es-mx/ia/rastreo-de-cargas/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es-mx/ia/rastreo-de-cargas"])
      });
    }
  